// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import AdminShellController from "./admin_shell_controller"
application.register("admin-shell", AdminShellController)

import SeasonDropdownController from "./season_dropdown_controller"
application.register("season-dropdown", SeasonDropdownController)

import IndexSearchController from "./index_search_controller"
application.register("index-search", IndexSearchController)

import ClickableRowController from "./clickable_row_controller"
application.register("clickable-row", ClickableRowController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import EventListController from "./event_list_controller"
application.register("event-list", EventListController)

import SurveyQuestionFormController from "./survey_question_form_controller"
application.register("survey-question-form", SurveyQuestionFormController)

import ReportFilterController from "./report_filter_controller"
application.register("report-filter", ReportFilterController)
